import React from 'react';
import styled from 'styled-components';

export type IProps = {
  confidence: number | null;
};

const CATConfidence: React.FC<IProps> = (props) => {
  if (props.confidence === null || props.confidence === 0) {
    return null;
  }

  // Convert to percentage (0-100)
  const confidencePercent = `${Math.round(props.confidence * 100)}%`;

  return (
    <Wrapper>
      <ConfidenceBadge $confidence={props.confidence}>{confidencePercent}</ConfidenceBadge>
    </Wrapper>
  );
};

export default CATConfidence;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConfidenceBadge = styled.span<{ $confidence: number }>`
  display: inline-flex;
  align-items: center;
  padding: 0px 5px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  background-color: ${(props) => {
    const conf = props.$confidence;
    if (conf >= 0.8) return '#e8f5e9';
    if (conf >= 0.6) return '#fff3e0';
    return '#ffebee';
  }};
  color: ${(props) => {
    const conf = props.$confidence;
    if (conf >= 0.8) return '#2e7d32';
    if (conf >= 0.6) return '#ef6c00';
    return '#c62828';
  }};
  border: 1px solid ${(props) => {
    const conf = props.$confidence;
    if (conf >= 0.8) return '#a5d6a7';
    if (conf >= 0.6) return '#ffcc80';
    return '#ef9a9a';
  }};
`;
